export var AvatarSize;
(function (AvatarSize) {
    AvatarSize["xLarge"] = "xLarge";
    AvatarSize["large"] = "large";
    AvatarSize["medium"] = "medium";
    AvatarSize["small"] = "small";
    AvatarSize["xSmall"] = "xSmall";
    AvatarSize["xxSmall"] = "xxSmall";
})(AvatarSize || (AvatarSize = {}));
export var ImageLoadStates;
(function (ImageLoadStates) {
    ImageLoadStates[ImageLoadStates["READY"] = 0] = "READY";
    ImageLoadStates[ImageLoadStates["LOADING"] = 1] = "LOADING";
    ImageLoadStates[ImageLoadStates["FAILURE"] = 2] = "FAILURE";
})(ImageLoadStates || (ImageLoadStates = {}));
/** *************************/
//# sourceMappingURL=types.js.map